import { useEffect } from "preact/hooks";
import PublicHeader from "../components/PublicHeader.js";
import PublicFooter from "../components/PublicFooter.js";

const posts = [
  {
    title: "Handling Large Payloads in n8n: The 16MB Problem and Solutions",
    href: "/blog/n8n-large-payloads",
    description:
      "How to handle webhook payloads that exceed n8n's size limits, whether you're self-hosted or on n8n Cloud.",
    publishedAt: "2026-04-16",
    readTime: "6 min read",
  },
  {
    title: "webhookstorage is live",
    href: "/blog/webhookstorage-is-live",
    description:
      "Announcing webhookstorage — a webhook buffer for large payloads. What it does, why it exists, what it costs, and what is already shipped.",
    publishedAt: "2026-03-11",
    readTime: "5 min read",
  },
];

export default function Blog() {
  useEffect(() => {
    document.title = "Blog — webhookstorage";

    let meta = document.querySelector('meta[name=\"description\"]');
    if (!meta) {
      meta = document.createElement("meta");
      meta.setAttribute("name", "description");
      document.head.appendChild(meta);
    }
    meta.setAttribute(
      "content",
      "Guides and explainers for large webhook payloads, automation platform limits, and production webhook architecture.",
    );

    let canonical = document.querySelector('link[rel="canonical"]');
    if (!canonical) {
      canonical = document.createElement("link");
      canonical.setAttribute("rel", "canonical");
      document.head.appendChild(canonical);
    }
    canonical.setAttribute("href", "https://webhookstorage.com/blog");
  }, []);

  return (
    <div class="min-h-screen bg-slate-50 text-slate-900">
      <PublicHeader current="blog" />

      <main class="mx-auto max-w-5xl px-4 py-12 sm:px-6 lg:px-8">
        <div class="max-w-3xl">
          <p class="text-sm font-semibold uppercase tracking-[0.24em] text-teal-700">
            Blog
          </p>
          <h1 class="mt-4 text-4xl font-bold tracking-tight text-slate-950">
            Practical notes on webhook payload limits
          </h1>
          <p class="mt-4 text-lg leading-8 text-slate-600">
            Short, technical writeups for teams moving large payloads through
            Shopify, Zapier, Make, n8n, and custom automation stacks.
          </p>
        </div>

        <div class="mt-12 grid gap-6">
          {posts.map((post) => (
            <article
              key={post.href}
              class="rounded-3xl border border-slate-200 bg-white p-8 shadow-sm"
            >
              <div class="flex flex-wrap items-center gap-3 text-sm text-slate-500">
                <span>{post.publishedAt}</span>
                <span>•</span>
                <span>{post.readTime}</span>
              </div>
              <h2 class="mt-3 text-2xl font-semibold tracking-tight text-slate-950">
                <a href={post.href} class="hover:text-teal-700">
                  {post.title}
                </a>
              </h2>
              <p class="mt-3 max-w-2xl text-base leading-7 text-slate-600">
                {post.description}
              </p>
              <a
                href={post.href}
                class="mt-6 inline-flex items-center text-sm font-semibold text-teal-700 hover:text-teal-800"
              >
                Read article
              </a>
            </article>
          ))}
        </div>
      </main>
      <PublicFooter />
    </div>
  );
}
